import { mdiHelpCircleOutline, mdiPhone } from '@mdi/js'
import type { VuetifyOptions } from 'vuetify'

export const vuetifyOptions: VuetifyOptions = {
  defaults: {
    VSnackbar: {
      location: 'bottom right',
      timeout: '4000',
    },
  },
  icons: {
    aliases: {
      phone: mdiPhone,
      help: mdiHelpCircleOutline,
    },
  },
}
